var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "47px",
    viewBox: "0 0 50 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.193971014 27.9504928 0.193971014 27.9504928 38.9564 0 38.9564"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administration---Importer-fichier",
    transform: "translate(-854.000000, -465.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(513.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(341.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.751428,40.699776 C32.8920081,41.2118944 40.7902664,37.5036147 43.2713154,30.2803716 C45.7038276,23.197537 41.7868463,14.6136191 35.3730572,11.5504051 C28.9592681,8.48786935 20.9677184,10.6469062 15.9999472,15.9797203 C13.3499649,18.8245209 11.4393807,22.5660374 11.0781913,26.5754834 C10.9010636,28.5405257 10.9767053,31.4172065 11.8144376,33.1970722 C12.3622099,34.3596827 13.0272268,35.4707422 13.8933247,36.3817024 C15.269374,37.8312348 17.2284951,38.4566297 19.0016635,39.1532464 C21.1694297,40.0051943 23.448137,40.5342702 25.751428,40.699776",
    id: "Fill-1",
    fill: "#FFE0B3",
    transform: "translate(27.500000, 25.446542) rotate(-210.000000) translate(-27.500000, -25.446542) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/water",
    transform: "translate(7.000000, 1.211826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9878145,35.1930377 C25.9878145,36.1860232 25.1806841,36.9939652 24.1872928,36.9939652 L3.76271304,36.9939652 C2.77053913,36.9939652 1.9621913,36.186429 1.9621913,35.1930377 L1.9621913,3.9568058 C1.9621913,2.96422609 2.77013333,2.15628406 3.76271304,2.15628406 L24.1872928,2.15628406 C25.1806841,2.15628406 25.9882203,2.96382029 25.9882203,3.9568058 L25.9882203,35.1930377 L25.9878145,35.1930377 Z M24.1872928,0.193849275 L3.76271304,0.193849275 C1.68827826,0.193849275 -0.000243478261,1.88196522 -0.000243478261,3.9568058 L-0.000243478261,35.1930377 C-0.000243478261,37.2682841 1.68827826,38.9564 3.76271304,38.9564 L24.1872928,38.9564 C26.2625391,38.9564 27.9506551,37.2682841 27.9506551,35.1930377 L27.9506551,3.9568058 C27.9506551,1.88196522 26.2625391,0.193849275 24.1872928,0.193849275 L24.1872928,0.193849275 Z",
    id: "Fill-1",
    fill: "#232323",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.36722082,15.8052935 L21.474354,15.8052935 C22.0911193,15.8052935 22.5910659,16.3052401 22.5910659,16.9220054 C22.5910659,17.5387708 22.0911193,18.0387174 21.474354,18.0387174 L6.36722082,18.0387174 C5.75045547,18.0387174 5.25050887,17.5387708 5.25050887,16.9220054 C5.25050887,16.3052401 5.75045547,15.8052935 6.36722082,15.8052935 Z",
    id: "Path",
    fill: "#232323",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36722082,21.8052935 L21.474354,21.8052935 C22.0911193,21.8052935 22.5910659,22.3052401 22.5910659,22.9220054 C22.5910659,23.5387708 22.0911193,24.0387174 21.474354,24.0387174 L6.36722082,24.0387174 C5.75045547,24.0387174 5.25050887,23.5387708 5.25050887,22.9220054 C5.25050887,22.3052401 5.75045547,21.8052935 6.36722082,21.8052935 Z",
    id: "Path",
    fill: "#232323",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36722082,27.6721413 L15.5423108,27.6721413 C16.1590762,27.6721413 16.6590228,28.1720879 16.6590228,28.7888533 C16.6590228,29.4056186 16.1590762,29.9055652 15.5423108,29.9055652 L6.36722082,29.9055652 C5.75045547,29.9055652 5.25050887,29.4056186 5.25050887,28.7888533 C5.25050887,28.1720879 5.75045547,27.6721413 6.36722082,27.6721413 Z",
    id: "Path",
    fill: "#232323",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36722082,9.93844565 L21.474354,9.93844565 C22.0911193,9.93844565 22.5910659,10.4383923 22.5910659,11.0551576 C22.5910659,11.671923 22.0911193,12.1718696 21.474354,12.1718696 L6.36722082,12.1718696 C5.75045547,12.1718696 5.25050887,11.671923 5.25050887,11.0551576 C5.25050887,10.4383923 5.75045547,9.93844565 6.36722082,9.93844565 Z",
    id: "Path",
    fill: "#232323",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.faf3c2544c80b264feadd6184d94e395.svg";
export { ForwardRef as ReactComponent };